import React, { useState } from 'react';
import { GridColumns, GridSortModel } from '@mui/x-data-grid';
import { RestoreDataGrid } from '@/RestoreComponent/DataGrid';
import { useGetCustomerCreditsUsed } from '@/api/finance/staff';
import moment from 'moment';

interface CustomerData {
  id: number;
}

interface UsedCreditsProps {
  customerAllData: CustomerData;
}

const initialSort: GridSortModel = [{ field: 'usedOnDate', sort: 'desc' }];

const columnConfig: GridColumns = [
  {
    field: 'noOfCreditsUsed',
    headerName: 'Credits Used',
    flex: 0.6,
    sortable: false
  },
  {
    field: 'issueDate',
    headerName: 'Date Issued',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) =>
      row.usedOnDate
        ? moment(row.issueDate).format('MM/DD/YYYY')
        : '--'
  },
  {
    field: 'source',
    headerName: 'Source',
    flex: 1,
    sortable: false
  },
  {
    field: 'usedOnDate',
    headerName: 'Date Used',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) =>
      row.usedOnDate
        ? moment(row.usedOnDate).format('MM/DD/YYYY')
        : '--'
  },
  {
    field: 'creditsAppliedTo',
    headerName: 'Credit Applied to Service',
    flex: 1.2,
    sortable: false
  },
  {
    field: 'usedStore',
    headerName: 'Used at Studio',
    flex: 1,
    sortable: false
  }
];

export default function UsedCredits({ customerAllData }: UsedCreditsProps) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortModel, setSortModel] = useState<GridSortModel>(initialSort);

  const { data, isLoading } = useGetCustomerCreditsUsed(
    { customerId: customerAllData?.id || 0 },
    {
      query: {
        enabled: !!customerAllData?.id
      }
    }
  );

  const allCredits = (data?.data || []).map((item, idx) => ({
    id: idx,
    ...item
  }));

  const sortField = sortModel[0]?.field;
  const sortDir = sortModel[0]?.sort;
  const sorted = [...allCredits].sort((a, b) => {
    if (!sortField) return 0;
    const valA = a[sortField as keyof typeof a] as string | number;
    const valB = b[sortField as keyof typeof b] as string | number;
    const cmp = valA < valB ? -1 : valA > valB ? 1 : 0;
    return sortDir === 'asc' ? cmp : -cmp;
  });

  const rows = sorted.slice(page * pageSize, (page + 1) * pageSize);

  return (
    <RestoreDataGrid
      rowCount={allCredits.length}
      columnConfig={columnConfig}
      rows={rows}
      loading={isLoading}
      page={page}
      pageSize={pageSize}
      pageSizes={[10, 50, 100]}
      sortModel={sortModel}
      onPageChange={p => setPage(p)}
      onPageChangeSize={ps => {
        setPageSize(ps);
        setPage(0);
      }}
      onSortModelChange={model => setSortModel(model)}
    />
  );
}
